export default __webpack_public_path__ + "static/media/elevate-wht-2.0e22abd2.png";